import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { Select } from 'foundations-components/transitional/components/Select';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { HR } from 'foundations-components/transitional/components/HR';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ValueComponent = ({
  children
}) => /*#__PURE__*/_jsx("span", {
  role: "button",
  children: children
});
export function ReviewFilter({
  filterKey,
  onUpdateFilters,
  options,
  placeholder,
  value
}) {
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    children: /*#__PURE__*/_jsx(Select, {
      buttonUse: "transparent",
      clearable: false,
      "data-test-id": `${filterKey}-reviews-list-select`,
      onChange: ({
        target: {
          value: newValue
        }
      }) => onUpdateFilters({
        [filterKey]: newValue
      }),
      options: options,
      placeholder: placeholder,
      value: value,
      valueComponent: ValueComponent
    }, filterKey)
  });
}
export function EcosystemReviewsFilters({
  handleUpdateFilters,
  ratingOptions,
  reviewFilters,
  showSearchBar,
  sortOptions
}) {
  const {
    inline
  } = useResponsiveProps({
    inline: {
      xs: false,
      lg: true
    }
  });
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      justifyContent: "space-between",
      flexDirection: inline ? 'row' : 'column-reverse',
      children: [/*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexWrap: "wrap",
        children: [ratingOptions && ratingOptions.length > 0 && /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          marginInlineEnd: "400",
          children: [/*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "-50",
            typography: "body-125",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-reviews.list.filter.label"
            })
          }), /*#__PURE__*/_jsx(ReviewFilter, {
            filterKey: "overallRating",
            onUpdateFilters: handleUpdateFilters,
            options: ratingOptions,
            placeholder: unescapedText(`marketplace-ui-reviews.list.filter.${ratingOptions[0].value}`),
            value: reviewFilters['overallRating']
          })]
        }), sortOptions && sortOptions.length > 0 && /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          marginInlineEnd: "400",
          children: [/*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "-50",
            typography: "body-125",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-ui-reviews.list.sort.label"
            })
          }), /*#__PURE__*/_jsx(ReviewFilter, {
            filterKey: "sort",
            onUpdateFilters: handleUpdateFilters,
            options: sortOptions,
            value: reviewFilters['sort']
          })]
        })]
      }), showSearchBar && /*#__PURE__*/_jsx(View, {
        inlineSize: inline ? '30%' : '100%',
        minInlineSize: "200px",
        children: /*#__PURE__*/_jsx(SearchInput, {
          value: reviewFilters.search,
          onChange: ({
            target: {
              value
            }
          }) => handleUpdateFilters({
            search: value
          })
        })
      })]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "small"
    })]
  });
}